import { FirmFilesView } from "@/components/features/settings/firm/FirmFilesView/FirmFilesView";
import FirmBusinessCardsCard from "@/components/features/settings/firm/firm-business-cards/FirmBusinessCardsCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/files")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.firmFiles)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <div className="flex flex-col gap-6">
      <FirmFilesView />
      <FirmBusinessCardsCard />
    </div>
  );
}
